// Thin wrapper around Meta Pixel (fbq). Safe if fbq is not loaded (ad blockers, dev).
// Every event uses SKU (or product id fallback) as content_ids so it matches the
// Commerce Manager catalog feed.

const skuOf = (p) => String(p?.sku || p?.id || "");

const safe = (event, payload) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event, payload);
    }
  } catch (_) { /* pixel blocked; ignore */ }
};

export const trackViewContent = (product) => {
  if (!product) return;
  safe("ViewContent", {
    content_type: "product",
    content_ids: [skuOf(product)],
    content_name: product.name,
    content_category: product.category,
    value: Number(product.our_price || 0),
    currency: "USD",
  });
};

export const trackAddToCart = (product, qty = 1) => {
  if (!product) return;
  safe("AddToCart", {
    content_type: "product",
    content_ids: [skuOf(product)],
    content_name: product.name,
    contents: [{ id: skuOf(product), quantity: qty, item_price: Number(product.our_price || 0) }],
    value: Number(product.our_price || 0) * qty,
    currency: "USD",
  });
};

export const trackInitiateCheckout = (items, subtotal) => {
  if (!items?.length) return;
  safe("InitiateCheckout", {
    content_type: "product",
    content_ids: items.map(skuOf),
    contents: items.map((i) => ({ id: skuOf(i), quantity: i.qty || 1, item_price: Number(i.our_price || 0) })),
    num_items: items.reduce((n, i) => n + (i.qty || 1), 0),
    value: Number(subtotal || 0),
    currency: "USD",
  });
};

export const trackPurchase = (order) => {
  if (!order) return;
  const items = order.items || [];
  safe("Purchase", {
    content_type: "product",
    content_ids: items.map((i) => String(i.sku || i.product_id || "")),
    contents: items.map((i) => ({ id: String(i.sku || i.product_id || ""), quantity: i.quantity || 1, item_price: Number(i.unit_price || 0) })),
    num_items: items.reduce((n, i) => n + (i.quantity || 1), 0),
    value: Number(order.total || 0),
    currency: "USD",
  });
};
